import React from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import { ParagraphProps } from "./Paragraph.props";
import styles from "./Paragraph.module.scss";

/**
 * @deprecated
 */
const Paragraph: React.FC<ParagraphProps> = ({
  children,
  id,
  testId,
  size = "reg",
  className,
  semiBold,
  isLoading = false,
}: ParagraphProps): JSX.Element => {
  const paragraphClasses = cn(
    [styles.paragraph],
    { [styles.xsmall]: size === "xsmall" },
    { [styles.small]: size === "small" },
    { [styles.large]: size === "large" },
    { [styles["small-display"]]: size === "small-display" },
    { [styles["semi-bold"]]: semiBold },
    className,
  );

  const paragraph = (
    <p className={paragraphClasses} id={id} data-testid={testId ? `test__${testId}` : undefined}>
      {children}
    </p>
  );

  return <>{isLoading ? <Skeleton height={20} /> : paragraph}</>;
};

/**
 * @deprecated
 */
export default Paragraph;
